import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { setFileId } from "reducers/files";
import { setCurrentLienStatus, setLiens } from "reducers/liens";
import { useGetLienByIdQuery, useGetLiensQuery } from "services/lien-api";
import { useDispatch } from "utils/redux";

type UseLiensDataProps = {
  fileId?: string | null;
};

export const useLiensData = ({ fileId }: UseLiensDataProps) => {
  const dispatch = useDispatch();
  const { lienId } = useParams<{ lienId?: string }>();

  // get single lien if we're on a lien detail page
  const { data: singleLien } = useGetLienByIdQuery(
    { lienId },
    { skip: !lienId },
  );

  // use fileId from URL or from the lien
  const effectiveFileId = fileId || (singleLien?.file?.id?.toString() ?? null);

  const {
    data: liens,
    isLoading,
    error,
  } = useGetLiensQuery(
    { fileId: effectiveFileId ?? "" },
    { skip: !effectiveFileId },
  );

  useEffect(() => {
    if (liens) {
      dispatch(setLiens(liens.results));

      // if we have a single lien, set its status in the reducer
      if (singleLien) {
        dispatch(
          setCurrentLienStatus({
            analysis_complete: singleLien.analysis_complete,
            client_submission: singleLien.client_submission,
            case_closed: singleLien.case_closed,
          }),
        );

        dispatch(setFileId(Number(effectiveFileId)));
      }
    }
  }, [liens, singleLien, dispatch, effectiveFileId]);

  return {
    liens,
    isLoading,
    error,
  };
};
